import * as Cesium from 'cesium';
import { QUALITY_SETTINGS, APP_CONFIG } from '../config/appConfig';
import { DATA_SOURCES } from '../config/dataSources';
import { buildingTilesetOptions } from '../cesium/performance';
import { applyBuildingFacadeShader } from './buildingFacadeShader';

export async function loadBuildingLod1(
  viewer: Cesium.Viewer,
  onError: (error: unknown) => void,
): Promise<Cesium.Cesium3DTileset> {
  try {
    const tileset = await Cesium.Cesium3DTileset.fromUrl(
      DATA_SOURCES.buildingLod1,
      {
        ...buildingTilesetOptions(),
        scene: viewer.scene,
      },
    );
    viewer.scene.primitives.add(tileset);
    applyBuildingFacadeShader(tileset, APP_CONFIG.defaultQuality);
    tileset.shadows = QUALITY_SETTINGS[APP_CONFIG.defaultQuality].shadows
      ? Cesium.ShadowMode.ENABLED
      : Cesium.ShadowMode.DISABLED;
    viewer.scene.requestRender();
    return tileset;
  } catch (error) {
    onError(error);
    throw error;
  }
}
